<template>
  <div :class="classes">
    <question-answer-item
      :selectable="blok.selectable || false"
      ref="qaEl"
      @select="expand(index, qaitem)"
      :key="index"
      v-for="(qaitem,index) in blok.items"
      :blok="qaitem"
    ></question-answer-item>
  </div>
</template>
<script>
import QuestionAnswerItem from "./QuestionAnswerItem";

export default {
  name: "question-answer-list",
  props: {
    blok: Object
  },
  components: {
    QuestionAnswerItem
  },
  methods: {
    expand: function(index, blok) {
      this.$refs.qaEl.map(e => e.collapse());
      this.$refs.qaEl[index].expand();
    }
  },
  computed: {
    classes: function() {
      const selected = this.selected;
      return {
        "question-answer-list": true,
        selectable: this.$props.blok.selectable
      };
    }
  }
};
</script>